<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <component-header
          title="Taxcode Master Config"
          @search-query="(val) => (filter = val)"
          :hasClear="false"
          @reload-data="reloadData"
          :hasReload="true"
          :isLoading="isloading"
          @create-press="$router.push({ name: 'CreateTaxCode' })"
        />
      </b-col>
    </b-row>
    <b-card class="card-wrap">
      <div class="mt-2">
        <b-table
          style="border-radius: 12px"
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :busy="isloading"
          :current-page="currentPage"
          :per-page="perPage"
          :items="taxcodes"
          thead-class="header"
          class="mt-3"
          :fields="Columns"
          show-empty
          :filter="filter"
          @filtered="onFilter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="mr-2 button-circle"
                variant="primary"
                @click="navigateTo(data, 'view')"
                v-b-modal.modal-center
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 button-circle"
                style="background: #fe7b08; border: #fe7b08;"
                variant="primary"
                @click="navigateTo(data, 'edit')"
                v-b-modal.modal-center-1
              >
                <i class="fas fa-pencil-alt edit"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 button-circle"
                variant="danger"
                @click="deleteTaxcode(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
            </div>
          </template>
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
        </b-table>
      </div>
      <div style="float: right" v-if="taxcodes.length > perPage">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="filterCount"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import createtaxcode from "@/components/MasterSetup/TaxCode/CreateTaxCode.vue";
import edittaxcode from "@/components/MasterSetup/TaxCode/EditTaxCode.vue";
//import EditTaxCodeModel from "@/components/MasterSetup/TaxCode/EditTaxCode.vue";
import viewtaxcode from "@/components/MasterSetup/TaxCode/ViewTaxCode.vue";
//import viewtaxcodemodel from "@/components/MasterSetup/TaxCode/ViewTaxCode.vue";
import moment from "moment";

export default {
  name: "TaxCodedetails",
  components: {
    ebButton,
    loader,
    createtaxcode,
    edittaxcode,
    viewtaxcode,
    ComponentHeader,
    //viewtaxcodemodel,
    //EditTaxCodeModel
  },
  data() {
    return {
      filterCount: 0,
      loading: false,
      sortBy: "createdAt",
      sortDesc: true,
      isloading: false,
      filter: "",
      perPage: 5,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      faqModal: false,
      header: "Edit Faq",
      taxcode: {},
      Columns: [
        {
          key: "Tax Code",
          sortable: true,
        },
        {
          key: "Country",
          sortable: true,
        },
        {
          key: "Start Date",
        },
        {
          key: "End Date",
        },

        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    taxcodes() {
      let data = this.$store.getters["taxcode/GetTaxcodeList"];

      this.loading = false;

      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => ({
          Country: d.country.toUpperCase(),
          "Start Date": moment(d.startDate).format("DD/MM/yyyy"),
          "End Date": moment(d.endDate).format("DD/MM/yyyy"),
          "Tax Code": d.taxCode,
          _id: d._id,
          restData: d,
        }));
      }
      return [];
    },
  },
  methods: {
    getTaxCodeData() {
      this.$store.dispatch("taxcode/fetchTaxcodeListforTenant");
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    navigateTo(data, type) {
      let obj = {
        country: data.item["Country"],
        startDate: data.item["Start Date"],
        endDate: data.item["End Date"],
        taxCode: data.item["Tax Code"],
        restData: data.item["restData"],
      };
      if (type === "edit") {
        this.$router.push({ name: "EditTaxCode", params: { data: obj } });
        return;
      }
      if (type === "view") {
        this.$router.push({ name: "ViewTaxCode", params: { data: obj } });
        return;
      }
    },
    async deleteTaxcode(data) {
      this.$swal({
        title: "Delete this Taxcode?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("taxcode/deleteTaxcode", data.item._id)
            .then((result) => {
              this.$toasted.success("Taxcode Deleted Successfully");
              this.$store
                .dispatch(
                  "taxcode/fetchTaxcodeListforTenant",
                  this.$store.getters["auth/getUserID"]
                )
                .catch((error) => {
                  this.$toasted.error(error.message);
                });
            });
        }
      });
    },
    async reloadData() {
      this.isloading = true;
      try {
        await this.$store.dispatch(
          "taxcode/fetchTaxcodeListforTenant",
          this.$store.getters["auth/getUserID"]
        );
      } catch (e) {
      } finally {
        this.isloading = false;
      }
    },
  },
  async mounted() {
    this.reloadData();
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
